/**
 * Decides whether the hard-block modal should replace the app for this client.
 *
 * Split out from the component so the decision is unit-testable: `useApplicationType`
 * derives `isElectron` from a module-level `electronBridge` binding rather than from
 * React context, so the Electron-true branch cannot be reached from a Cypress mount.
 *
 * Web is excluded on purpose — cad-next on the web is where we are migrating people
 * to, so there is nowhere better to send them.
 */
export function shouldBlockOutOfDateClient({
    legacyAppDeprecation,
    isElectron,
    outOfDate,
}: {
    legacyAppDeprecation: boolean;
    isElectron: boolean;
    outOfDate: boolean | undefined;
}): boolean {
    return legacyAppDeprecation && isElectron && outOfDate === true;
}
